import {
  BanIcon,
  ChevronDown,
  Filter,
  Loading2,
  Localisation,
  Plus,
  SearchLoop,
  SortIcon,
} from 'assets/icons/index.js';
import axios from 'axios';
import Button from 'components/button/index.js';
import Badge from 'components/badge/badge.js';
import useModal from 'components/modal/useModal.js';
import Pagination from 'components/pagination/pagination.js';
import UseContext from 'hooks/useContext.js';
import useWindowDimensions from 'hooks/useWindowDimensions.js';
import { useEffect, useState } from 'react';
import useAbortController from '../../../../../hooks/useAbortController.js';
import TableVivier from './components/table.vivier.js';
import FilterDropdown from '../../../../../components/filter/FilterDropdown';
import SubNavbar from '../../../../../components/SubNavbar/SubNavbar.js';
import StyledInput from '../../../../../components/styledInput/StyledInput';
import MediaQuery from 'react-responsive';
import BottomSheet from '../../../../../components/bottomSheet/BottomSheet';

function BodyVivier() {
  // vivierListUSer
  // #region **** UseState ****
  const { toggle } = useModal();
  const { height, width } = useWindowDimensions();
  const { setInfoVivier, usersVivier, setUsersVivier, setObjID } = UseContext();
  const [search, setSearch] = useState('');
  const [optionSearch, setOptionSearch] = useState('');
  const [selectMQ, setSelectMQ] = useState(false);
  const [selectGP, setSelectGP] = useState(false);
  const [selectProfil, setSelectProfil] = useState(false);
  const [selectApp, setSelectApp] = useState(false);
  const [searchCandidatWaiting, setSearchCandidatWaiting] = useState(true);
  const [sortName, setSortName] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [limitElement, setLimitElement] = useState(25);
  const [totalPages, setTotalPages] = useState(0);
  const [countPerPage, setCountPerPage] = useState(0);
  const [countTotal, setCountTotal] = useState(0);
  const [data, setData] = useState();
  const [result, setResult] = useState();
  const [listAddVivier, setAddVivier] = useState([]);
  const token = localStorage.getItem('xsrfToken');
  const [osChecked, setOsChecked] = useState({
    web: true,
    app: true,
  });
  const [departmentChecked, setDepartmentChecked] = useState({
    martinique: true,
    guadeloupe: true,
    other: true,
  });
  const [sortChecked, setSortChecked] = useState({
    a_z: false,
    recent: false,
  });

  // États pour le BottomSheet mobile
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [tempSearch, setTempSearch] = useState('');
  const [tempOptionSearch, setTempOptionSearch] = useState('');
  const [tempOsChecked, setTempOsChecked] = useState({ web: true, app: true });
  const [tempDepartmentChecked, setTempDepartmentChecked] = useState({ martinique: true, guadeloupe: true, other: true });
  const [tempSortChecked, setTempSortChecked] = useState({ a_z: false, recent: false });

  const openFilterSheet = () => {
    setTempSearch(search);
    setTempOptionSearch(optionSearch);
    setTempOsChecked({ ...osChecked });
    setTempDepartmentChecked({ ...departmentChecked });
    setTempSortChecked({ ...sortChecked });
    setIsFilterOpen(true);
  };

  const applyFilters = () => {
    setSearch(tempSearch);
    setOptionSearch(tempOptionSearch);
    setOsChecked(tempOsChecked);
    setDepartmentChecked(tempDepartmentChecked);
    setSortChecked(tempSortChecked);
    setIsFilterOpen(false);
  };

  const getAbortController = useAbortController();

  const handleSelectMartinique = (e) => {
    e.preventDefault();
    if (!selectMQ) {
      setSelectMQ(true);
      setSelectGP(false);
    } else {
      setSelectMQ(false);
      setSelectGP(false);
    }
  };

  const handleSelectGuadeloupe = (e) => {
    e.preventDefault();
    if (!selectGP) {
      setSelectMQ(false);
      setSelectGP(true);
    } else {
      setSelectMQ(false);
      setSelectGP(false);
    }
  };

  const handleSelectProfil = (e) => {
    e.preventDefault();
    setSelectProfil((prevState) => !prevState);
  };

  const handleSelectApp = (e) => {
    e.preventDefault();
    setSelectApp((prevState) => !prevState);
  };

  const handleAddVivier = () => {
    setInfoVivier({ listUsers: listAddVivier });
    toggle('vivier_add');
  };

  const manageCandidatSearch = async () => {
    setSearchCandidatWaiting(true);
    const controller = getAbortController();

    try {
      const filterOptions = {
        ...osChecked,
        ...departmentChecked,
        ...sortChecked,
      };

      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}vivier/vivierListUser`,
        {
          signal: controller.signal,
          params: {
            page: currentPage,
            limit: limitElement,
            search: search,
            optionSearch: optionSearch,
            profil: selectProfil,
            filterOptions: JSON.stringify(filterOptions),
          },
        }
      );

      if (selectProfil) setCurrentPage(1);
      setTotalPages(data.countPages);
      setCountPerPage(limitElement);
      setCountTotal(data.count);
      setData(data.count);
      setResult(data.users);
      setSearchCandidatWaiting(false);
    } catch (error) {
      if (error.name !== 'CanceledError') {
        console.error('An error occurred:', error);
        setSearchCandidatWaiting(false);
      }
    }
  };

  let timerViverSearch = '';
  useEffect(() => {
    timerViverSearch = setTimeout(async () => {
      await manageCandidatSearch();
    }, 400);
    return () => clearTimeout(timerViverSearch);
  }, [
    search,
    optionSearch,
    selectGP,
    selectMQ,
    sortName,
    currentPage,
    selectProfil,
    selectApp,
    osChecked,
    departmentChecked,
    sortChecked,
  ]);

  // Convert sortChecked to list format for FilterDropdown
  const sortList = [
    { value: 'a_z', label: 'A-Z', checked: sortChecked.a_z },
    { value: 'recent', label: 'Récent', checked: sortChecked.recent },
  ];

  const handleSortChange = (updatedList) => {
    const newSortChecked = { a_z: false, recent: false };
    updatedList.forEach((item) => {
      if (item.checked) {
        newSortChecked[item.value] = true;
      }
    });
    setSortChecked(newSortChecked);
  };

  // Convert osChecked to list format for FilterDropdown
  const osList = [
    { value: 'web', label: 'Web', checked: osChecked.web },
    { value: 'app', label: 'App', checked: osChecked.app },
  ];

  const handleOsChange = (updatedList) => {
    const newOsChecked = { web: false, app: false };
    updatedList.forEach((item) => {
      if (item.checked) {
        newOsChecked[item.value] = true;
      }
    });
    setOsChecked(newOsChecked);
  };

  // Convert departmentChecked to list format for FilterDropdown
  const departmentList = [
    { value: 'martinique', label: 'Martinique', checked: departmentChecked.martinique },
    { value: 'guadeloupe', label: 'Guadeloupe', checked: departmentChecked.guadeloupe },
    { value: 'other', label: 'Aucun', checked: departmentChecked.other },
  ];

  const handleDepartmentChange = (updatedList) => {
    const newDepartmentChecked = { martinique: false, guadeloupe: false, other: false };
    updatedList.forEach((item) => {
      if (item.checked) {
        newDepartmentChecked[item.value] = true;
      }
    });
    setDepartmentChecked(newDepartmentChecked);
  };

  const excludeAgency = () => {
    setInfoVivier({ listUsers: listAddVivier });
    toggle('exclude_agency');
  };

  const changeLocalisation = () => {
    setInfoVivier({ listUsers: listAddVivier });
    toggle('localisation_preferences');
  };

  useEffect(() => {
    if (usersVivier.length > 0) {
      for (let i = 0; i < usersVivier.length; i++) {
        for (let j = 0; j < result.length; j++) {
          if (usersVivier[i].id_user.toString() === result[j]._id.toString()) {
            let isInVivier = false;
            if (usersVivier[i].preferences_department?.department) {
              if (
                departmentChecked.martinique &&
                usersVivier[i].preferences_department?.department ===
                  'Martinique'
              ) {
                isInVivier = true;
              } else if (
                departmentChecked.guadeloupe &&
                usersVivier[i].preferences_department?.department ===
                  'Guadeloupe'
              ) {
                isInVivier = true;
              }
            } else {
              isInVivier = true;
            }

            if (!isInVivier) {
              result[j].isDeleted = true;
            } else {
              result[j].viviers =
                usersVivier[i].viviers?.map((vivier) => vivier.name) || [];
            }
          }
        }
      }
      setResult(result);
      setUsersVivier([]);
      setInfoVivier({ listUsers: [] });
      setAddVivier([]);
    }
  }, [usersVivier]);

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <SubNavbar>
        <div className="flex justify-between items-center w-full gap-3">
          {/* Desktop: Left side - Filters and search */}
          <MediaQuery minWidth={768}>
            <div className="flex-1 overflow-x-auto overflow-y-hidden" style={{ WebkitOverflowScrolling: 'touch', scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
              <div className="flex gap-3 items-center min-w-max">
                <FilterDropdown
                  value={
                    Object.keys(osChecked).filter((key) => osChecked[key]).length > 0
                      ? `${Object.keys(osChecked).filter((key) => osChecked[key]).length} Os`
                      : 'Os'
                  }
                  list={osList}
                  onChange={handleOsChange}
                  type="selectMultipleCheckbox"
                  classNameValue="text-sm h-10 px-4 flex items-center justify-center"
                />
                <FilterDropdown
                  value={
                    Object.keys(departmentChecked).filter((key) => departmentChecked[key]).length > 0
                      ? Object.keys(departmentChecked).filter((key) => departmentChecked[key]).length > 1
                        ? `${Object.keys(departmentChecked).filter((key) => departmentChecked[key]).length} Départements`
                        : `${Object.keys(departmentChecked).filter((key) => departmentChecked[key]).length} Département`
                      : 'Département'
                  }
                  list={departmentList}
                  onChange={handleDepartmentChange}
                  type="selectMultipleCheckbox"
                  classNameValue="text-sm h-10 px-4 flex items-center justify-center"
                />
                <FilterDropdown
                  value={<SortIcon wh={20} color={'#374151'} />}
                  list={sortList}
                  onChange={handleSortChange}
                  type="selectMultipleRadio"
                  showChevron={false}
                  classNameValue="w-10 h-10 flex items-center justify-center"
                />
                <div className="flex gap-3 items-center">
                  <div className="w-full tab:flex-1 tab:max-w-[280px]">
                    <StyledInput
                      type="text"
                      placeholder="Rechercher..."
                      imgFront={<SearchLoop wh={16} color="#6B7280" />}
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                  <div className="w-full tab:max-w-[140px]">
                    <select
                      className="w-full h-10 pl-2 pr-3 ft-b placeholder-gray-600 border rounded-lg text-sm focus:border-yellow-500 focus:outline-none"
                      onChange={(e) => setOptionSearch(e.target.value)}
                      value={optionSearch}
                    >
                      <option value="">Tous</option>
                      <option value="id_bestt">ID BeSTT</option>
                      <option value="name">Nom</option>
                      <option value="mail">Email</option>
                      <option value="phone">Téléphone</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </MediaQuery>
          {/* Mobile: Filter button + Tabs */}
          <MediaQuery maxWidth={767}>
            <div className="flex items-center gap-3 min-w-max">
              <Button
                color={'SECONDARY'}
                size={'SM'}
                onClick={openFilterSheet}
              >
                <Filter wh={16} color="#374151" />
                <span>Filtrer</span>
              </Button>
            </div>
          </MediaQuery>
        </div>
      </SubNavbar>
      <div className="flex flex-col w-full h-full overflow-hidden">
        <div className="flex-1 overflow-auto">
          {searchCandidatWaiting && (
            <div className="p-3 tab:p-4 lg:p-8">
              <div
                className={`flex flex-col ${
                  width <= 460 ? 'gap-5' : 'gap-10'
                } justify-center items-center h-80`}
              >
                <div className={'animate-spin'}>
                  <Loading2 wh={width <= 460 ? 40 : 60} color={'#FF9600'} />
                </div>
              </div>
            </div>
          )}
          {!searchCandidatWaiting && (
            <div className="h-full">
              <TableVivier
                users={result}
                isWaiting={searchCandidatWaiting}
                setSortName={setSortName}
                sortName={sortName}
                setAddVivier={setAddVivier}
                list={listAddVivier}
              />
            </div>
          )}
        </div>
        {!searchCandidatWaiting &&
        currentPage &&
        totalPages >= 1 &&
        setCurrentPage ? (
          <div className="flex-shrink-0 border-t border-gray-100 bg-white px-8 py-4">
            <Pagination
              currentPage={currentPage}
              countPerPage={countPerPage}
              countTotal={countTotal}
              totalPages={totalPages}
              setCurrentPage={setCurrentPage}
            />
          </div>
        ) : null}

        {/* Fixed bottom bar for multiple selection actions */}
        {listAddVivier.length > 0 && (
          <div className="fixed bottom-2 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white p-1.5 rounded z-50">
            <div className="flex items-center text-sm h-10">
              <div className="flex gap-1 items-center py-2 px-3">
                <div className="w-fit">
                  <Badge type="WARNING">{listAddVivier.length}</Badge>
                </div>
                sélectionné{listAddVivier.length > 1 ? 's' : ''}
              </div>
              <div className="w-0.5 h-1/2 self-center bg-white" />
              <button
                onClick={() => handleAddVivier()}
                className="flex gap-1 items-center py-2 px-3 rounded hover:bg-gray-700"
              >
                <Plus wh={16} color="#FFF" />
                <span>Ajouter au vivier</span>
              </button>
              <div className="w-0.5 h-1/2 self-center bg-white" />
              <button
                onClick={() => changeLocalisation()}
                className="flex gap-1 items-center py-2 px-3 rounded hover:bg-gray-700"
              >
                <Localisation wh={16} color="#FFF" />
                <span>Localisation</span>
              </button>
              <div className="w-0.5 h-1/2 self-center bg-white" />
              <button
                onClick={() => excludeAgency()}
                className="flex gap-1 items-center py-2 px-3 rounded hover:bg-gray-700 text-red-400"
              >
                <BanIcon wh={16} color="#F87171" />
                <span>Exclure</span>
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Bottom Sheet Filtre pour mobile */}
      <BottomSheet
        isOpen={isFilterOpen}
        onClose={() => setIsFilterOpen(false)}
        title="Filtrer"
      >
        <div className="flex flex-col gap-4">
          {/* Recherche */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Rechercher
            </label>
            <StyledInput
              type="text"
              placeholder="Rechercher..."
              imgFront={<SearchLoop wh={16} color="#6B7280" />}
              value={tempSearch}
              onChange={(e) => setTempSearch(e.target.value)}
            />
          </div>

          {/* Type de recherche */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Rechercher par
            </label>
            <select
              className="w-full h-10 pl-3 pr-8 ft-b placeholder-gray-600 border rounded-lg text-sm focus:border-yellow-500 focus:outline-none"
              onChange={(e) => setTempOptionSearch(e.target.value)}
              value={tempOptionSearch}
            >
              <option value="">Tous</option>
              <option value="id_bestt">ID BeSTT</option>
              <option value="name">Nom</option>
              <option value="mail">Email</option>
              <option value="phone">Téléphone</option>
            </select>
          </div>

          {/* Os */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Os
            </label>
            <div className="flex gap-4">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={tempOsChecked.web}
                  onChange={(e) => setTempOsChecked({ ...tempOsChecked, web: e.target.checked })}
                  className="w-4 h-4"
                />
                <span className="text-sm">Web</span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={tempOsChecked.app}
                  onChange={(e) => setTempOsChecked({ ...tempOsChecked, app: e.target.checked })}
                  className="w-4 h-4"
                />
                <span className="text-sm">App</span>
              </label>
            </div>
          </div>

          {/* Département */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Département
            </label>
            <div className="flex flex-col gap-2">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={tempDepartmentChecked.martinique}
                  onChange={(e) => setTempDepartmentChecked({ ...tempDepartmentChecked, martinique: e.target.checked })}
                  className="w-4 h-4"
                />
                <span className="text-sm">Martinique</span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={tempDepartmentChecked.guadeloupe}
                  onChange={(e) => setTempDepartmentChecked({ ...tempDepartmentChecked, guadeloupe: e.target.checked })}
                  className="w-4 h-4"
                />
                <span className="text-sm">Guadeloupe</span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={tempDepartmentChecked.other}
                  onChange={(e) => setTempDepartmentChecked({ ...tempDepartmentChecked, other: e.target.checked })}
                  className="w-4 h-4"
                />
                <span className="text-sm">Aucun</span>
              </label>
            </div>
          </div>

          {/* Tri */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Trier par
            </label>
            <div className="flex gap-4">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  name="sort"
                  checked={tempSortChecked.a_z}
                  onChange={() => setTempSortChecked({ a_z: true, recent: false })}
                  className="w-4 h-4"
                />
                <span className="text-sm">A-Z</span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  name="sort"
                  checked={tempSortChecked.recent}
                  onChange={() => setTempSortChecked({ a_z: false, recent: true })}
                  className="w-4 h-4"
                />
                <span className="text-sm">Récent</span>
              </label>
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  name="sort"
                  checked={!tempSortChecked.a_z && !tempSortChecked.recent}
                  onChange={() => setTempSortChecked({ a_z: false, recent: false })}
                  className="w-4 h-4"
                />
                <span className="text-sm">Aucun</span>
              </label>
            </div>
          </div>

          {/* Bouton Appliquer */}
          <div className="mt-2">
            <Button
              color={'PRIMARY'}
              size={'FULL'}
              onClick={applyFilters}
            >
              Appliquer
            </Button>
          </div>
        </div>
      </BottomSheet>
    </div>
  );
}

export default BodyVivier;
